import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
//import MarsLogo from '../assets/MARS_logo-removebg-preview.png'; // Adjust the path as necessary
import MarketResearchImage from '../assets/MARS.png'; // adjust path if needed



const MarketResearch = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const featureBoxRef = useRef(null);
  const listItemsRef = useRef([]);
  const noteRef = useRef(null);
  const buttonRef = useRef(null);
  const imageRef = useRef(null);

  const handleNavigate = (path) => {
    navigate(path);
    // Scroll to top after navigation
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    // Observe all animated elements
    const elementsToObserve = [
      titleRef.current,
      descriptionRef.current,
      featureBoxRef.current,
      noteRef.current,
      buttonRef.current,
      imageRef.current,
      ...listItemsRef.current
    ].filter(Boolean);

    elementsToObserve.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      elementsToObserve.forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  return (
    <section className="market-research" ref={sectionRef}>
      <div className="container market-research-container">
        <div className="section-content">
          

          <div 
            className="mars-product-header slide-in-right" 
            ref={titleRef}
            style={{ animationDelay: '0.2s' }}
            >
              <div className="mars-logo-with-underline">
                <span className="mars-home-product-subtitle">
                Market Research
                </span>
            </div>
            
          </div>
          <div className="icon-container">
            
          </div>

          <p className="mars-home-section-description fade-up" ref={descriptionRef}>
            <strong>How is your business performing within the current industry landscape?</strong> 
            <p>Have you ever evaluated your business's position in the present market environment? When was the last time you reviewed how well your business is navigating the current industry trends?</p>
          </p>
          
          <div className="feature-box fade-up" ref={featureBoxRef}>
            <p>Our <strong>Market Research</strong> analysis offers a customised evaluation that provides clarity on a client's competitive landscape. This thorough analysis is tailored specifically to our client's industry, region or product niche. By integrating various data sources, we present a comprehensive overview of market dynamics, including:</p>
          </div>
          
          <div className="feature-box">
            <h3 
              className="fade-left"
              ref={(el) => listItemsRef.current[0] = el}
            >
              <li> Quantitative data such as statistics, market size, and growth rates.</li>
            </h3>
            <h3 
              className="fade-left"
              ref={(el) => listItemsRef.current[1] = el}
            >
              <li> Qualitative insights from websites, news and comments.</li>
            </h3>
          </div>
          
          <p className="feature-note fade-up" ref={noteRef}>
            This personalised approach ensures that our clients receive actionable insights directly relevant their business,
            empowering them to make informed strategic decisions for a competitive edge.
          </p>
          
          <button 
            className="learn-more-button scale-up" 
            onClick={() => handleNavigate('/marketresearch')}
            ref={buttonRef}
          >
            Learn more
          </button>
        </div>
        <div className="mars-section-image fade-right" ref={imageRef}>
          <img src={MarketResearchImage} alt="Market Research" className="market-research-image" />
        </div>
      </div>
    </section>
  );
};

export default MarketResearch;
